import { useFormContext } from '../../form/context';
import type { TCaseTypes } from '../models';

export const useCaseMatch = (type: TCaseTypes) => {
    const { status } = useFormContext();

    if (Array.isArray(type)) {
        return type.includes(status);
    }

    return status === type;
};
